import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { radioButtonWidget } from "../../utils/general";
import { fontColorArr, fontsizeArr } from "../../utils/general";

function DropdownWidgetOption(props) {
  const [dropdownOptionList, setDropdownOptionList] = useState(["option-1"]);
  const [minCount, setMinCount] = useState(0);
  const [maxCount, setMaxCount] = useState(0);
  const [dropdownName, setDropdownName] = useState(props.type);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isHideLabel, setIsHideLabel] = useState(true);
  const [status, setStatus] = useState("required");
  const [defaultValue, setDefaultValue] = useState("");
  const statusArr = ["required", "optional"];
  const [defaultCheckbox, setDefaultCheckbox] = useState([]);

  const resetState = () => {
    setDropdownOptionList(["option-1"]);
    setDropdownName(props.type);
    setIsReadOnly(false);
    setIsHideLabel(true);
    setMinCount(0);
    setMaxCount(0);
    setDefaultCheckbox([]);
    setDefaultValue("");
  };

  useEffect(() => {
    if (
      props.currWidgetsDetails?.options?.name &&
      props.currWidgetsDetails?.options?.values
    ) {
      setDropdownName(props.currWidgetsDetails?.options?.name);
      setDropdownOptionList(props.currWidgetsDetails?.options?.values);
      setMinCount(
        props.currWidgetsDetails?.options?.validation?.minRequiredCount
      );
      setMaxCount(
        props.currWidgetsDetails?.options?.validation?.maxRequiredCount
      );
      setIsReadOnly(props.currWidgetsDetails?.options?.isReadOnly);
      setIsHideLabel(props.currWidgetsDetails?.options?.isHideLabel ?? true);
      setStatus(props.currWidgetsDetails?.options?.status || "required");
      setDefaultValue(props.currWidgetsDetails?.options?.defaultValue || "");
      setDefaultCheckbox(props.currWidgetsDetails?.options?.defaultValue || []);
    } else {
      setStatus("required");
      resetState();
    }
  }, [props.currWidgetsDetails]);

  // Separate useEffect for auto-saving checkbox
  useEffect(() => {
    if (
      props.type === "checkbox" &&
      props.showDropdown &&
      !props.currWidgetsDetails?.options?.values
    ) {
      const defaultData =
        defaultCheckbox && defaultCheckbox.length > 0
          ? defaultCheckbox
          : defaultValue;
      props.handleSaveWidgetsOptions(
        dropdownName,
        dropdownOptionList,
        minCount,
        maxCount,
        isReadOnly,
        null,
        null,
        status,
        defaultData,
        isHideLabel
      );
    }
  }, [props.showDropdown, props.type, props.currWidgetsDetails]);

  const handleInputChange = (index, value) => {
    setDropdownOptionList((prevInputs) => {
      const newInputs = [...prevInputs];
      newInputs[index] = value;
      return newInputs;
    });
  };

  //function add add checkbox option and add width of checkbox
  const handleAddInput = () => {
    const deleteOption = false;
    const addOption = true;
    setDropdownOptionList((prevInputs) => [...prevInputs, ""]);
    props.handleSaveWidgetsOptions(
      null,
      null,
      null,
      null,
      null,
      addOption,
      deleteOption
    );
  };

  //function add add checkbox option and delete width of checkbox
  const handleDeleteInput = (ind) => {
    const deleteOption = true;
    const addOption = false;
    const getUpdatedOptions = dropdownOptionList.filter(
      (data, index) => index !== ind
    );
    setDropdownOptionList(getUpdatedOptions);
    props.handleSaveWidgetsOptions(
      null,
      null,
      null,
      null,
      null,
      addOption,
      deleteOption
    );
  };

  const handleSaveOption = () => {
    const defaultData =
      defaultCheckbox && defaultCheckbox.length > 0
        ? defaultCheckbox
        : defaultValue;

    props.handleSaveWidgetsOptions(
      dropdownName,
      dropdownOptionList,
      minCount,
      maxCount,
      isReadOnly,
      null,
      null,
      status,
      defaultData,
      isHideLabel
    );
    //  props.setShowDropdown(false);
    setDropdownOptionList(["option-1"]);
    setDropdownName(props.type);
    //  props.setCurrWidgetsDetails({});
    setIsReadOnly(false);
    setIsHideLabel(true);
    setMinCount(0);
    setMaxCount(0);
    setDefaultCheckbox([]);
    setDefaultValue("");
  };

  const handleDefaultCheck = (index) => {
    const getDefaultCheck = defaultCheckbox.includes(index);
    if (getDefaultCheck) {
      return true;
    } else {
      return false;
    }
  };

  const modalContent = (
    <div
      className={`fixed inset-0 overflow-y-auto ${
        props.showDropdown ? "block" : "hidden"
      }`}
      style={{ zIndex: 9999 }}
    >
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSaveOption();
            }}
          >
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    {props.title}
                  </h3>

                  <div className="mt-4 space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        required
                        defaultValue={dropdownName}
                        value={dropdownName}
                        onChange={(e) => setDropdownName(e.target.value)}
                        className="appearance-none rounded relative block w-full px-3 py-2 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Options
                      </label>
                      <div className="space-y-3">
                        {dropdownOptionList.map((option, index) => (
                          <div
                            key={index}
                            className="flex items-center space-x-2"
                          >
                            {props.type === "checkbox" && (
                              <input
                                type="checkbox"
                                checked={handleDefaultCheck(index)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    const getDefaultCheck =
                                      defaultCheckbox?.includes(index);
                                    if (!getDefaultCheck) {
                                      setDefaultCheckbox((prev) => [
                                        ...prev,
                                        index,
                                      ]);
                                    }
                                  } else {
                                    const removeOption = defaultCheckbox.filter(
                                      (data) => data !== index
                                    );
                                    setDefaultCheckbox(removeOption);
                                  }
                                }}
                                className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                              />
                            )}
                            <input
                              required
                              className="appearance-none rounded relative block w-full px-3 py-2 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
                              type="text"
                              value={option}
                              onChange={(e) =>
                                handleInputChange(index, e.target.value)
                              }
                            />
                            <button
                              type="button"
                              onClick={() => handleDeleteInput(index)}
                              className="text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={handleAddInput}
                          className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-primary bg-primary/5 hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                        >
                          <i className="fas fa-plus mr-2"></i> Add Option
                        </button>
                      </div>
                    </div>

                    {["dropdown", radioButtonWidget].includes(props.type) && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Default Value
                        </label>
                        <select
                          onChange={(e) => setDefaultValue(e.target.value)}
                          className="appearance-none rounded relative block w-full px-3 py-2 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
                          value={defaultValue}
                        >
                          <option value="" disabled hidden>
                            Select default value
                          </option>
                          {dropdownOptionList.map((data, ind) => (
                            <option key={ind} value={data}>
                              {data}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="flex items-center space-x-4">
                      <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Font Size
                        </label>
                        <select
                          className="rounded relative block w-full px-3 py-2 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
                          value={
                            props.fontSize ||
                            props.currWidgetsDetails?.options?.fontSize ||
                            12
                          }
                          onChange={(e) =>
                            props.setFontSize(parseInt(e.target.value))
                          }
                        >
                          {fontsizeArr.map((size, ind) => (
                            <option key={ind} value={size}>
                              {size}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Color
                        </label>
                        <select
                          value={
                            props.fontColor ||
                            props.currWidgetsDetails?.options?.fontColor ||
                            "black"
                          }
                          onChange={(e) => props.setFontColor(e.target.value)}
                          className="rounded relative block w-full px-3 py-2 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
                        >
                          {fontColorArr.map((color, ind) => (
                            <option key={ind} value={color}>
                              {color}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {props.type === "checkbox" && (
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center">
                          <input
                            id="isreadonly"
                            type="checkbox"
                            checked={isReadOnly}
                            onChange={(e) => setIsReadOnly(e.target.checked)}
                            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                          />
                          <label
                            htmlFor="isreadonly"
                            className="ml-2 text-sm text-gray-700"
                          >
                            Read Only
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                disabled={dropdownOptionList.length === 0}
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
              >
                Save
              </button>
              {props.currWidgetsDetails?.options?.values?.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    props.handleClose && props.handleClose();
                    resetState();
                  }}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  return props.showDropdown
    ? createPortal(modalContent, document.body)
    : null;
}

export default DropdownWidgetOption;
